import React from 'react';
import { Layout } from '../components/common';
import { Redirect, Switch } from 'react-router-dom';
import UserTable from '../components/Users/UserTable';
import UserFormContainer from '../components/Users/UsersForm/UserFormContainer';
import RolesTable from '../components/Roles/RolesTable';
import RolesForm from '../components/Roles/RolesForm/RolesForm';
import DocumentTable from '../components/Documents/DocumentTable';
import ProfileFormContainer from '../components/Profile/ProfileFormContainer';
import Config from '../components/Config/Config'
import { getCookie } from '../utils/utils';
import DocTypeFormComponent from '../components/Documents/DocumentsTypeForm/DocTypeFormComponent';
import AccessGroupsTable from '../components/AccessGroups/AccessGroupsTable';
import AccessGroupsTableComponent from '../components/AccessGroups/AccessGroupsFormComponent';
import ProtectedFeatureRoute from '../components/common/ProtectedFeatureRoute';
import AuditLogsTable from '../components/AuditLogs/AuditLogsTable';
import DocTypeImportComponent from '../components/Documents/DocTypeImportComponent';

export default function Home(props) {

  return (
    <Layout history={props.history}>
      <Switch>
        <ProtectedFeatureRoute exact path="/home/users" component={UserTable} />
        <ProtectedFeatureRoute exact path="/home/audit" component={AuditLogsTable} />
        <ProtectedFeatureRoute exact path="/home/users/:id" component={UserFormContainer} />
        <ProtectedFeatureRoute exact path="/home/roles" component={RolesTable} />
        <ProtectedFeatureRoute exact path="/home/roles/:id" component={RolesForm} />
        <ProtectedFeatureRoute exact path="/home/profile" component={ProfileFormContainer} />
        <ProtectedFeatureRoute exact path="/home/documentTypes" component={DocumentTable}/>
        <ProtectedFeatureRoute exact path="/home/config" component={Config}/>
        <ProtectedFeatureRoute exact path="/home/documentTypes/import" component={DocTypeImportComponent}/>
        <ProtectedFeatureRoute exact path="/home/documentTypes/:id" component={DocTypeFormComponent}/>
        <ProtectedFeatureRoute exact path="/home/accessGroups" component={AccessGroupsTable} />
        <ProtectedFeatureRoute exact path="/home/accessGroups/:id" component={AccessGroupsTableComponent}/>
        <Redirect from="/home" to={JSON.parse(getCookie('routeOptions'))[0].path} exact />
        <Redirect from="/home/*" to="/404" />
      </Switch>
    </Layout>
  );
}
